import React from 'react';

type Props = {
  variant: string;
  children: React.ReactNode;
  className?: string;
};

const Badge: React.FC<Props> = ({ variant, children, className }) => {
  const classes = ['badge', `badge-${variant}`, className].filter(Boolean).join(' ');
  return <span className={classes}>{children}</span>;
};

export default Badge;
